import {HttpInterceptorFn} from '@angular/common/http';

const headerName = 'TL-Window-Id';

export function getOrSetWindowId(): string {
    const id = window.sessionStorage.getItem(headerName);
    if (id) {
        return id;
    }

    const newId = window.crypto.randomUUID();
    window.sessionStorage.setItem(headerName, newId);

    return newId;
}

export const windowIdHeaderInterceptor: HttpInterceptorFn = (request, next) => {
    const id = getOrSetWindowId();

    const newRequest = request.clone({
        headers: request.headers.set(headerName, id)
    });

    return next(newRequest);
};
